import watchActivateAccountSaga from './activateAccountSaga';
import watchActivatePlaceSaga from './activatePlaceSaga';
import watchFetchActivatePlaceSaga from './fetchActivatePlaceSaga';
import watchFetchEmployeeInvitationSaga from './fetchEmployeeInvitationSaga';
import watchRegisterCompanySaga from './registerCompanySaga';
import watchRegisterEmployeeSaga from './registerEmployeeSaga';

const registrationSagas = [
  watchActivateAccountSaga(),
  watchActivatePlaceSaga(),
  watchFetchActivatePlaceSaga(),
  watchFetchEmployeeInvitationSaga(),
  watchRegisterCompanySaga(),
  watchRegisterEmployeeSaga(),
];
export default registrationSagas;
